import { generatePath } from 'react-router-dom'

export const endpoints = {
    sendTrainingEmail: (userUUID: string): string =>
        generatePath('usermetadata/:userUUID/send-training-email/', { userUUID }),
    sendOrganizationEmail: 'company/companyUUID/send-organization-email/',
}
